export default __webpack_public_path__ + "static/media/Blooded Bracers of Passing Spirits.59e4b551.jpg";